import { render, staticRenderFns } from "./StudentRedemptions.vue?vue&type=template&id=6d84fd0c&scoped=true&"
import script from "./StudentRedemptions.vue?vue&type=script&lang=js&"
export * from "./StudentRedemptions.vue?vue&type=script&lang=js&"
import style0 from "./StudentRedemptions.vue?vue&type=style&index=0&id=6d84fd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84fd0c",
  null
  
)

export default component.exports